import { type IComponentPropsConfig } from '@/page-interface';
import { type SvelteComponent } from 'svelte';

const components: Record<string, SvelteComponent> = {};

/**
 * 管理组件实例
 *
 * @param config 组件配置
 * @returns
 */
export const useComponentInstance = (config: IComponentPropsConfig) => {
  const componentInstanceId = getSvelteComponentContextIndex(config);

  const setComponentInstance = (instance: SvelteComponent) => {
    components[componentInstanceId] = instance;
  };

  const getComponentInstance = () => {
    const instance = components[componentInstanceId];
    if (!instance) {
      throw new Error('[sca]: current instance is empty');
    }
    return instance;
  };

  const getAllInstances = () => components;

  return {
    getComponentInstance,
    setComponentInstance,
    getAllInstances,
  };
};

function getSvelteComponentContextIndex(config: {
  id: number;
  type: string;
}) {
  return `${config.type}-${config.id}`;
}
